<template lang="pug">
  .cuadro-container
    loading(v-if="isLoading")
    info-card(
      v-if="!isLoading"
      :title="o.titulo"
      :number="o.cantidad"
      :iconClass="o.iconClass"
    )
</template>

<script>
import { apiGet } from '../../util/general';
import InfoCard from '../charts/c_info_card';

export default {
  name: 'cantidad_contratos_sin_firmar',
  components: {
    'info-card': InfoCard
  },
  data () {
    return {
      o: {
        cantidad:'',
        titulo: 'Contratos sin firmar',
        iconClass:'fa-pencil'
      },
      isLoading: true
    };
  },
  created () {
    this.fetch();
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/kpi/cantidad-contratos-sin-firmar', {}, function (data) {
        if (data.cantidad === 0) {
          vm.$emit('close')
          return
        }
        vm.o.cantidad = data.cantidad
      }, function (error) {
        console.error('error', error)
      }, function () {
        vm.isLoading = false
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// c_kpi_cantidad_contratos_sin_firmar.vue?5a5c1872